import { render, staticRenderFns } from "./front-listedhistory.vue?vue&type=template&id=6892d8db"
import script from "./front-listedhistory.vue?vue&type=script&lang=ts"
export * from "./front-listedhistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports